import {environment} from "@env";
import { coreLogger } from "@core/r2";

const logger = coreLogger(environment.print_logs);

export {
    logger
}
